import notice from "./assets/images/notice.png";


export default () => (
    <img src={notice} alt="" style={{ width: "100%" }} />
  );
  